// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import { Link, useParams } from "react-router-dom";

// Local Imports
import CustomModal from "../../components/custom-modal/custom-modal";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import TakePortfolioActionService from "./take-portfolio-action.service";
import CollapseComponent from "../../components/collapse.component";
import moment from "moment";
import ReactCountryFlag from "react-country-flag";
import TakeAction from "../../components/take-action/take-action";
import clsx from "clsx";
import TakeDepositActionService from "../take-deposit-action/take-deposit-action.service";
import { extractToEntity, formatNumber } from "../../utils/helper/functions";
import { Divider, Image } from "antd";
import PdfViewer from "src/components/pdf-viewer";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const TakePortfolioAction: React.FC = (): ReactElement => {
  const user = useSelector((state: any) => state?.user);
  const takePortfolioActionService = new TakePortfolioActionService();
  const takeDepositActionService = new TakeDepositActionService();
  const { portfolioId }: { [key: string]: string | undefined } = useParams();
  const [portfolioDetailsData, setPortfolioDetailsData] = useState<any>();
  const [openRejectModal, setOpenRejectModal] = useState<boolean>(false);
  const [openRejectDepositModal, setOpenRejectDepositModal] =
    useState<boolean>(false);
  const [openApproveDepositModal, setOpenApproveDepositModal] =
    useState<boolean>(false);
  const [openApprovePortfolioModal, setOpenApprovePortfolioModal] =
    useState<boolean>(false);
  const [openPdfViewerModal, setOpenPdfViewerModal] = useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] = useState<any>({});

  useEffect(() => {
    fetchPortfolioDetailsData();
  }, []);

  const onRejectPortfolio = async (value: string) => {
    const response: string | undefined =
      await takePortfolioActionService.rejectPortfolio(portfolioId, value);
    if (response === "success") {
      fetchPortfolioDetailsData();
      setOpenRejectModal(false);
    }
  };

  const onApprovePortfolio = async (date: string) => {
    const formatedDate = dayjs(date)
      .hour(12)
      .minute(0)
      .second(0)
      .millisecond(0);

    const response: string | undefined =
      await takePortfolioActionService.ApprovePortfolio(
        portfolioId,
        formatedDate
      );
    if (response === "success") {
      fetchPortfolioDetailsData();
      setOpenApprovePortfolioModal(false);
    }
  };

  const fetchPortfolioDetailsData = async (): Promise<void> => {
    const data = await takePortfolioActionService.getPortfolioDetailsData(
      portfolioId
    );

    if (data !== undefined) {
      setPortfolioDetailsData(data);
    }
  };

  const onApproveDeposit = async (value: string) => {
    const response: string | undefined =
      await takeDepositActionService.takeAction(
        portfolioDetailsData?.payments[0]?.id,
        "approve",
        value
      );
    if (response === "success") {
      fetchPortfolioDetailsData();
      setOpenApproveDepositModal(false);
    }
  };

  const onRejectDeposit = async (value: string) => {
    const response: string | undefined =
      await takeDepositActionService.takeAction(
        portfolioDetailsData?.payments[0]?.id,
        "reject",
        value
      );
    if (response === "success") {
      fetchPortfolioDetailsData();
      setOpenRejectDepositModal(false);
    }
  };

  return (
    portfolioDetailsData && (
      <section className="flex flex-col">
        <BreadcrumbComponent />
        <div className="flex flex-col pb-7 flex-grow">
          <CollapseComponent
            header={
              <div className="flex gap-3 items-center">
                <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
                <h3 className=" text-xl font-semibold">
                  Portfolio details{" "}
                  {portfolioDetailsData?.status === "Opened" ||
                    portfolioDetailsData?.status === "Rejected" ? (
                    <span
                      className={clsx(
                        "text-base font-semibold w-fit px-3 py-2 ms-3 rounded-md  text-white",
                        portfolioDetailsData?.status === "Opened"
                          ? "bg-green-100"
                          : "bg-red-200"
                      )}
                    >
                      {portfolioDetailsData?.status}
                    </span>
                  ) : (
                    ""
                  )}
                </h3>
              </div>
            }
          >
            <div className="flex gap-5 flex-wrap mb-5">
              <div className="w-[32%] flex flex-col">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Account#
                </p>
                <Link
                  to={`/home/business-account/${portfolioDetailsData?.account?.id}/${portfolioDetailsData?.account?.activeKycId}/details`}
                  className=" text-base font-semibold text-lightGray-200 underline"
                >
                  {portfolioDetailsData?.account?.accountCode}
                </Link>
              </div>
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Account type
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {portfolioDetailsData?.account?.clientType?.description} -{" "}
                  {portfolioDetailsData?.account?.clientSubType?.description}
                </span>
              </div>
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Account status
                </p>
                <span className=" text-base font-semibold w-fit px-3 py-1 rounded-md bg-green-100 text-white">
                  {portfolioDetailsData?.account?.accountStatus?.description}
                </span>
              </div>

              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Portfolio#
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {portfolioDetailsData?.status !== "Rejected"
                    ? portfolioDetailsData?.accountCode ||
                    portfolioDetailsData?.account?.accountCode + " - New"
                    : "-"}
                </span>
              </div>
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Portfolio type
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {portfolioDetailsData?.portfolioType?.nameEn}
                </span>
              </div>
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Portfolio status
                </p>
                <span
                  className={clsx(
                    "text-base font-semibold w-fit px-3 py-1 rounded-md text-white",
                    portfolioDetailsData?.status === "Opened"
                      ? "bg-green-100"
                      : portfolioDetailsData?.status === "Rejected"
                        ? "bg-red-200"
                        : "bg-yellow-500"
                  )}
                >
                  {portfolioDetailsData?.status === "Pending"
                    ? "New"
                    : portfolioDetailsData?.status === "PENDING_DEPOSIT"
                      ? "Pending Deposit"
                      : portfolioDetailsData?.status}
                </span>
              </div>
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Portfolio currency
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {portfolioDetailsData?.portfolioCurrency || "-"}
                </span>
              </div>
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Minimum value
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {portfolioDetailsData?.portfolioType?.minimumAmount
                    ? formatNumber(
                      portfolioDetailsData?.portfolioType?.minimumAmount
                    )
                    : "-"}
                </span>
              </div>
              {portfolioDetailsData?.status !== "Pending" &&
                portfolioDetailsData?.actionBy && (
                  <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                    <p className=" text-black-300 text-xs font-normal mb-[10px]">
                      Action by
                    </p>
                    <span className=" text-base font-semibold text-lightGray-200">
                      {portfolioDetailsData?.actionBy?.name || "-"}
                    </span>
                  </div>
                )}
              {portfolioDetailsData?.status !== "Pending" &&
                portfolioDetailsData?.actionDate && (
                  <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                    <p className=" text-black-300 text-xs font-normal mb-[10px]">
                      Action date
                    </p>
                    <span className=" text-base font-semibold text-lightGray-200">
                      {portfolioDetailsData?.actionDate
                        ? moment(portfolioDetailsData?.actionDate).format(
                          "DD MMM, YYYY hh:mm A"
                        )
                        : "-"}
                    </span>
                  </div>
                )}
              {portfolioDetailsData?.status === "Rejected" && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Status reason
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {portfolioDetailsData?.portfolioStatusReason || "-"}
                  </span>
                </div>
              )}
              {portfolioDetailsData?.openDate && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Open date
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {moment(portfolioDetailsData?.openDate).format(
                      "DD MMM, YYYY"
                    )}
                  </span>
                </div>
              )}

              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Wealth manager
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {portfolioDetailsData?.account?.wealthManager?.ae1 || "-"}
                </span>
              </div>
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Wealth manager email
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {portfolioDetailsData?.account?.wealthManager?.ae1Email ||
                    "-"}
                </span>
              </div>
              {portfolioDetailsData?.account?.wealthManager?.ae2 && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Wealth manager
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {portfolioDetailsData?.account?.wealthManager?.ae2 || "-"}
                  </span>
                </div>
              )}
              {portfolioDetailsData?.account?.wealthManager?.ae2 && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Wealth manager email
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {portfolioDetailsData?.account?.wealthManager?.ae2Email ||
                      "-"}
                  </span>
                </div>
              )}
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Online trading
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {portfolioDetailsData?.onlineTradeSys ? "Yes" : "No"}
                </span>
              </div>

              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Pledged
                </p>
                <span
                  className={clsx(
                    "rounded-md w-fit",
                    portfolioDetailsData?.portfolioDisclaimer
                      ? "bg-[#FFAF00] text-white text-sm font-medium p-2"
                      : "bg-transparent text-lightGray-200 font-semibold text-base p-0"
                  )}
                >
                  {portfolioDetailsData?.portfolioDisclaimer
                    ? extractToEntity(portfolioDetailsData?.portfolioDisclaimer)
                    : "No"}
                </span>
              </div>
            </div>
            {portfolioDetailsData?.agreementPdf ? (
              <div className="view flex align-center">
                <img
                  src={"/images/info.svg"}
                  alt="view info portfolio agreement"
                />

                <span
                  className="underline cursor-pointer text-blue-500"
                  onClick={() => {
                    setSelectedDocument(portfolioDetailsData?.agreementPdf);
                    setOpenPdfViewerModal(true);
                  }}
                >
                  View portfolio agreement
                </span>
              </div>
            ) : (
              ""
            )}
            {portfolioDetailsData?.status === "Pending" &&
              user?.permissions?.includes("request_portfolios_approver") && (
                <div className="flex gap-7 justify-end items-center">
                  <button
                    onClick={() => setOpenRejectModal(true)}
                    className="rounded-lg bg-white w-fit px-14 py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
                  >
                    Reject
                  </button>
                  <button
                    onClick={() => setOpenApprovePortfolioModal(true)}
                    className="rounded-lg bg-blue-500 w-fit px-14 py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white"
                  >
                    {portfolioDetailsData?.payments?.length ? "Step 1/2 - Create portfolio" : " Create portfolio"}
                  </button>
                </div>
              )}
          </CollapseComponent>

          {portfolioDetailsData?.payments?.length ? (
            <CollapseComponent
              header={
                <div className="flex gap-3 items-center">
                  <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
                  <h3 className=" text-xl font-semibold">
                    Deposit details{" "}
                    {portfolioDetailsData?.payments[0]?.status === "Opened" ||
                      portfolioDetailsData?.payments[0]?.status === "Rejected" ||
                      portfolioDetailsData?.payments[0]?.status === "Approved" ||
                      portfolioDetailsData?.status === "Rejected" ? (
                      <span
                        className={clsx(
                          "text-base font-semibold w-fit px-3 py-2 ms-3 rounded-md  text-white",
                          portfolioDetailsData?.payments[0]?.status ===
                            "Opened" ||
                            portfolioDetailsData?.payments[0]?.status ===
                            "Approved"
                            ? "bg-green-100"
                            : "bg-red-200"
                        )}
                      >
                        {portfolioDetailsData?.status === "Rejected"
                          ? "Cancelled"
                          : portfolioDetailsData?.payments[0]?.status}
                      </span>
                    ) : (
                      ""
                    )}
                  </h3>
                </div>
              }
            >
              <div className="flex gap-5 flex-wrap mb-5">
                <div className="w-[32%] flex flex-col">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Amount
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {portfolioDetailsData?.payments[0]?.amount
                      ? formatNumber(portfolioDetailsData?.payments[0]?.amount)
                      : "-"}
                  </span>
                </div>
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Currency
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {portfolioDetailsData?.payments[0]?.currency}
                  </span>
                </div>
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Payment method
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {portfolioDetailsData?.payments[0]?.paymentMethod}
                  </span>
                </div>
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Bank referenece
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.kamcoBank?.refrence}
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && <Divider />}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "Knet" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Payment ID
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.gatewayPaymentId}
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "Knet" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Reference ID
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.gatewayRef}
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "Knet" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Result
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.gatewayResult}
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "Knet" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Tracking ID
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.gatewayTrackId}
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "Knet" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Transaction ID
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.gatewayTransId}
                      </span>
                    </div>
                  )}

                {portfolioDetailsData?.payments[0]?.paymentMethod === "Knet" &&
                  portfolioDetailsData?.payments[0]?.card?.cardNumber && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Card number
                      </p>
                      <div className="flex items-center gap-2">
                        <span className=" text-base font-semibold text-lightGray-200">
                          {portfolioDetailsData?.payments[0]?.card?.cardNumber}
                        </span>
                        {!portfolioDetailsData?.payments[0]?.card
                          ?.cardImage && (
                            <img src={`/images/tick-circle.svg`} alt="" />
                          )}
                      </div>
                    </div>
                  )}

                {portfolioDetailsData?.payments[0]?.paymentMethod === "Knet" &&
                  portfolioDetailsData?.payments[0]?.card?.cardHolderName && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Name on card
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {
                          portfolioDetailsData?.payments[0]?.card
                            ?.cardHolderName
                        }
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod === "Knet" &&
                  portfolioDetailsData?.payments[0]?.card?.cardExpiryDate && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Expiry date
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {
                          portfolioDetailsData?.payments[0]?.card
                            ?.cardExpiryDate
                        }
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <h3 className="text-lg w-full font-semibold">Kamco bank</h3>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Bank name
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {
                          portfolioDetailsData?.payments[0]?.kamcoBank
                            ?.accountName
                        }
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Country
                      </p>
                      <div className="flex items-center gap-2">
                        <ReactCountryFlag
                          style={{
                            fontSize: "24px",
                          }}
                          countryCode={
                            portfolioDetailsData?.payments[0]?.kamcoBank?.country
                              ?.countryCode
                          }
                          svg
                        />
                        <span className=" text-base font-semibold text-lightGray-200">
                          {portfolioDetailsData?.payments[0]?.kamcoBank?.country
                            ?.nameEn || "-"}
                        </span>
                      </div>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        IBAN
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.kamcoBank?.iban}
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Swift code
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.kamcoBank?.swiftCode}
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && <Divider />}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <h4 className="text-lg w-full font-semibold">Client bank</h4>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Bank name
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {portfolioDetailsData?.payments[0]?.paymentBank?.bank
                          ?.bankName || "-"}
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Country
                      </p>
                      <div className="flex items-center gap-2">
                        <ReactCountryFlag
                          style={{
                            fontSize: "24px",
                          }}
                          countryCode={
                            portfolioDetailsData?.payments[0]?.paymentBank
                              ?.accountCountry?.countryCode
                          }
                          svg
                        />
                        <span className=" text-base font-semibold text-lightGray-200">
                          {portfolioDetailsData?.payments[0]?.paymentBank
                            ?.accountCountry?.nameEn || "-"}
                        </span>
                      </div>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        IBAN
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {
                          portfolioDetailsData?.payments[0]?.paymentBank
                            ?.ibanNumber
                        }
                      </span>
                    </div>
                  )}
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Swift code
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {
                          portfolioDetailsData?.payments[0]?.paymentBank
                            ?.swiftCode
                        }
                      </span>
                    </div>
                  )}
                <Divider />

                {(portfolioDetailsData?.payments[0]?.paymentCardFront ||
                  portfolioDetailsData?.payments[0]?.transferReceipt ||
                  portfolioDetailsData?.payments[0]?.card?.cardImage) && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Attachment
                      </p>
                      <Image
                        src={
                          portfolioDetailsData?.payments[0]?.paymentCardFront ||
                          portfolioDetailsData?.payments[0]?.transferReceipt ||
                          portfolioDetailsData?.payments[0]?.card?.cardImage
                        }
                        width={"80px"}
                        height={"50px"}
                        alt=""
                      />
                    </div>
                  )}
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Client notes
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {portfolioDetailsData?.payments[0]?.remarks || "-"}
                  </span>
                </div>
                {portfolioDetailsData?.payments[0]?.paymentMethod ===
                  "WireTransfer" && (
                    <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                      <p className=" text-black-300 text-xs font-normal mb-[10px]">
                        Request date
                      </p>
                      <span className=" text-base font-semibold text-lightGray-200">
                        {moment(portfolioDetailsData?.createdAt).format(
                          "DD MMM, YYYY hh:mm A"
                        )}
                      </span>
                    </div>
                  )}
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Deposit date
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {portfolioDetailsData?.payments[0]?.depositDate
                      ? moment(
                        portfolioDetailsData?.payments[0]?.depositDate
                      ).format("DD MMM, YYYY hh:mm A")
                      : "-"}
                  </span>
                </div>
                {(portfolioDetailsData?.payments[0]?.status === "Approved" ||
                  portfolioDetailsData?.payments[0]?.status === "Rejected") && (
                    <>
                      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                        <p className=" text-black-300 text-xs font-normal mb-[10px]">
                          {portfolioDetailsData?.payments[0]?.status ===
                            "Approved"
                            ? "Prospero deposit transaction ID"
                            : "Status reason"}
                        </p>
                        <span className=" text-base font-semibold text-lightGray-200">
                          {portfolioDetailsData?.payments[0]?.status ===
                            "Approved"
                            ? portfolioDetailsData?.payments[0]?.transactionId ||
                            "-"
                            : portfolioDetailsData?.payments[0]?.statusReason ||
                            "-"}
                        </span>
                      </div>
                      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                        <p className=" text-black-300 text-xs font-normal mb-[10px]">
                          Action by
                        </p>
                        <span className=" text-base font-semibold text-lightGray-200">
                          {portfolioDetailsData?.payments[0]?.actionBy?.name ||
                            "-"}
                        </span>
                      </div>
                      <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                        <p className=" text-black-300 text-xs font-normal mb-[10px]">
                          Action date
                        </p>
                        <span className=" text-base font-semibold text-lightGray-200">
                          {moment(
                            portfolioDetailsData?.payments[0]?.actionDate
                          ).format("DD MMM, YYYY hh:mm A")}
                        </span>
                      </div>
                    </>
                  )}
              </div>
              {portfolioDetailsData?.status !== "Pending" &&
                portfolioDetailsData?.status !== "Rejected" &&
                portfolioDetailsData?.payments[0]?.status === "Pending" &&
                user?.permissions?.includes("request_deposit_approver") && (
                  <div className="flex gap-7 justify-end items-center">
                    <button
                      onClick={() => setOpenRejectDepositModal(true)}
                      className="rounded-lg bg-white w-fit px-14 py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
                    >
                      Reject
                    </button>
                    <button
                      onClick={() => setOpenApproveDepositModal(true)}
                      className="rounded-lg bg-blue-500 w-fit px-14 py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white"
                    >
                      Step 2/2 - Approve deposit
                    </button>
                  </div>
                )}
            </CollapseComponent>
          ) : (
            ""
          )}
        </div>
        <CustomModal
          isVisible={openRejectModal}
          centered
          width={450}
          onClose={() => {
            setOpenRejectModal(false);
          }}
        >
          <TakeAction
            label="Rejection reason"
            action="reject"
            fieldName="statusReason"
            errorName="reason"
            onCancel={() => setOpenRejectModal(false)}
            onSubmit={(value) => onRejectPortfolio(value)}
          />
        </CustomModal>

        <CustomModal
          isVisible={openApprovePortfolioModal}
          centered
          width={450}
          onClose={() => {
            setOpenApprovePortfolioModal(false);
          }}
        >
          <TakeAction
            label="Open date"
            action="approve"
            fieldName="openDate"
            errorName="open date"
            date={true}
            onCancel={() => setOpenApprovePortfolioModal(false)}
            onSubmit={(value) => onApprovePortfolio(value)}
          />
        </CustomModal>

        <CustomModal
          isVisible={openApproveDepositModal}
          centered
          width={450}
          onClose={() => {
            setOpenApproveDepositModal(false);
          }}
        >
          <TakeAction
            label="Prospero deposit transaction ID"
            action="approve"
            fieldName="transactionId"
            errorName="deposit transaction ID"
            onCancel={() => setOpenApproveDepositModal(false)}
            onSubmit={(value) => onApproveDeposit(value)}
          />
        </CustomModal>

        <CustomModal
          isVisible={openRejectDepositModal}
          centered
          width={450}
          onClose={() => {
            setOpenRejectDepositModal(false);
          }}
        >
          <TakeAction
            label="Rejection reason"
            action="reject"
            fieldName="statusReason"
            errorName="reason"
            onCancel={() => setOpenRejectDepositModal(false)}
            onSubmit={(value) => onRejectDeposit(value)}
          />
        </CustomModal>

        <CustomModal
          isVisible={openPdfViewerModal}
          centered
          width={1100}
          showClose={false}
          onClose={() => {
            setOpenPdfViewerModal(false);
          }}
          className="edit-modal"
        >
          <div className="flex flex-col items-center justify-center">
            <PdfViewer fileUrl={selectedDocument} />
          </div>
        </CustomModal>
      </section>
    )
  );
};

export default TakePortfolioAction;
